/* Furniture Instore — keeps a bed's options with their bed in the basket.

   A divan base's storage, headboard and mattress go in as their own lines (Advanced
   plan: no cart transform to bundle them). Each carries _fi_option, and the bed it
   was chosen with carries _fi_bed, with the same token. When the basket changes and
   an option has more units than its bed — the bed was removed, or its quantity
   lowered — the option is brought down to match.

   Loaded by layout/theme.liquid only where it can act: a bed product page, or any
   page whose basket already holds a bed option. */
(function () {
  'use strict';

  if (window.FIBedGuard) return;
  window.FIBedGuard = true;

  var running = false;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function fixes(cart) {
    var beds = {};
    (cart.items || []).forEach(function (item) {
      var bed = item.properties && item.properties._fi_bed;
      if (bed) beds[bed] = (beds[bed] || 0) + item.quantity;
    });
    var updates = {};
    var any = false;
    (cart.items || []).forEach(function (item) {
      var owner = item.properties && item.properties._fi_option;
      if (!owner) return;
      var allowed = beds[owner] || 0;
      if (item.quantity > allowed) {
        updates[item.key] = allowed;
        any = true;
      }
    });
    return any ? updates : null;
  }

  function drawerItems() {
    return document.querySelector('cart-drawer-items');
  }

  function render(state) {
    var items = drawerItems();
    if (!items || !state.sections || typeof items.getSectionsToRender !== 'function') return;
    items.getSectionsToRender().forEach(function (section) {
      var html = state.sections[section.section];
      var host = document.getElementById(section.id);
      if (!html || !host) return;
      var target = host.querySelector(section.selector) || host;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', state.item_count === 0);
  }

  /* The basket as the theme's own change just returned it, when it came with its
     lines. Saves a round trip on every quantity change and removal. */
  function cartFrom(event) {
    var data = event && event.cartData;
    return data && Array.isArray(data.items) ? data : null;
  }

  function check(known) {
    if (running) return;
    running = true;
    var cart = known
      ? Promise.resolve(known)
      : fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
          return response.json();
        });
    cart
      .then(function (cart) {
        var updates = fixes(cart);
        if (!updates) return null;

        /* The cart page renders its own sections; reloading it is the one way to be
           sure every total on it agrees with the basket. */
        var onCartPage = !!document.getElementById('main-cart-items');
        var body = { updates: updates };
        var items = drawerItems();
        if (!onCartPage && items && typeof items.getSectionsToRender === 'function') {
          body.sections = items.getSectionsToRender().map(function (section) {
            return section.section;
          });
          body.sections_url = window.location.pathname;
        }

        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (state) {
            if (onCartPage) {
              window.location.reload();
              return;
            }
            render(state);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fi-bed-guard', cartData: state });
            }
          });
      })
      .catch(function () {
        /* Nothing to undo: the basket is as the customer left it. */
      })
      .finally(function () {
        running = false;
      });
  }

  (function watch() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(watch, 300);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      /* Adds are never a reason to remove anything, and our own update must not
         answer itself. */
      if (!event || event.source === 'fi-bed-guard' || event.source === 'product-form') return;
      check(cartFrom(event));
    });
  })();

  /* A basket changed in another tab, or before this page loaded, is put right here. */
  if (document.getElementById('main-cart-items')) check();
})();
